<script setup lang="ts">
defineProps({
    autocomplete: { type: String as PropType<'new-password' | 'current-password'>, required: true },
});
const model = defineModel<string>();
const isPasswordVisible = ref<boolean>(false);
</script>

<template>
    <UInput v-model.trim="model" :type="isPasswordVisible ? 'text' : 'password'" :autocomplete="autocomplete">
        <template #trailing>
            <UButton
                color="neutral"
                variant="link"
                :icon="isPasswordVisible ? 'lucide:eye-off' : 'lucide:eye'"
                class="px-0 py-0"
                @click="isPasswordVisible = !isPasswordVisible"
            />
        </template>
    </UInput>
</template>
